import React from 'react';
import { Box } from '@atlaskit/primitives/box';
import { Inline } from '@atlaskit/primitives/inline';
import { Stack } from '@atlaskit/primitives/stack';
import { Text } from '@atlaskit/primitives/text';
import { xcss } from '@atlaskit/primitives/xcss';
import Image from '@atlaskit/image';
import { useIntl } from 'react-intl';
import { CATEGORIES } from '../components/menu-page/CategorySidebar';
import { AnnouncementCoreData } from './announcements';
import { messages } from './messages';
import themingBeforeImg from '../assets/images/theming_before.png';
import themingAfterImg from '../assets/images/theming_after.png';

const contentStyles = xcss({
	marginTop: 'space.200',
});

const ImageStyles = xcss({
	width: '100%',
});

export const ThemingAnnouncement = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box>
			<Inline space="space.200">
				<Box xcss={ImageStyles}>
					<Image alt={formatMessage(messages.themingImageBeforeAlt)} src={themingBeforeImg} />
				</Box>
				<Box xcss={ImageStyles}>
					<Image alt={formatMessage(messages.themingImageAfterAlt)} src={themingAfterImg} />
				</Box>
			</Inline>
			<Stack space="space.200" xcss={contentStyles}>
				{formatMessage(messages.themingIntro, {
					bold: (text: React.ReactNode) => <b>{text}</b>,
				})}
				<Stack space="space.200">
					<Text>{formatMessage(messages.themingDescriptionFirstSection)}</Text>
					<Text>{formatMessage(messages.themingDescriptionSecondSection)}</Text>
					<Text>
						{formatMessage(messages.themingDescriptionThirdSection, {
							bold: (text: React.ReactNode) => <b>{text}</b>,
							link: (text: React.ReactNode) => (
								<a
									href="https://community.atlassian.com/forums/Atlassian-AI-Rovo-articles/Brand-Rovo-as-your-company-s-search-amp-chat-company-theming-now/ba-p/3040952"
									rel="noopener noreferrer"
									target="_blank"
								>
									{text}
								</a>
							),
						})}
					</Text>
				</Stack>
			</Stack>
		</Box>
	);
};

export const ThemingAnnouncementData: AnnouncementCoreData = {
	title: messages.themingTitle.defaultMessage,
	content: <ThemingAnnouncement />,
	tags: [CATEGORIES.EXTENSION],
};

export default ThemingAnnouncement;
